"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDmanagementToExcel = convertDmanagementToExcel;
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.typed.uint8-array");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _encodingJapanese = _interopRequireDefault(require("encoding-japanese"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _fileSaver = require("file-saver");
var _defaultFormat = require("@/utils/import-formats/default-format");
// D-Management ヘッダー → 標準フォーマットヘッダーのマッピング
var COLUMN_MAP = {
  '会員コード': '会員ID',
  '会社名': '会社名',
  '会社名フリガナ': '会社名_ふりがな',
  '会員名': '会員名',
  '会員名フリガナ': '会員名_ふりがな',
  '社内役職': '役職名',
  '業種コード': '業種コード',
  '郵便番号': '郵便番号',
  '会社住所': '会社所在地',
  '会社電話番号': '電話番号',
  '会社ＦＡＸ番号': 'FAX',
  '事業概要': '事業内容',
  'E-mail': 'Email',
  'URL': 'ホームページ',
  '正規社員数': '社員数',
  'パート社員数': 'パート_アルバイト数',
  '入会年': '入会年',
  '資本金': '資本金',
  '設立年': '設立年月日',
  '創業ｏｒ設立年': '設立年月日'
};

// バリデーション用: D-Management側の期待ヘッダー
var EXPECTED_HEADERS = Object.keys(COLUMN_MAP);

// 標準フォーマットのヘッダー一覧 (24列)
var OUTPUT_HEADERS = _defaultFormat.defaultFormat.fields.map(function (f) {
  return f.header;
});

// zoneId → 都道府県コードのマッピング
var ZONE_PREFIX_MAP = {
  '1': '34',
  '2': '27',
  '3': '38',
  '4': '03',
  '5': '99',
  // デモ同友会。都道府県コードがないため99を仮置き。
  '6': '15',
  '7': '08'
};

/**
 * ファイルをArrayBufferとして読み込み、エンコーディングを自動判定してテキストに変換
 */
function readFileAsText(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      try {
        var codes = new Uint8Array(reader.result);
        var encode = _encodingJapanese.default.detect(codes);
        // Encoding.detectがSJISを正しく判定できない場合があるため、
        // UTF8/UNICODE以外、または判定結果で日本語が文字化けする場合はSJISを試行
        if (!encode || encode !== 'UTF8' && encode !== 'UTF16') {
          encode = 'SJIS';
        }
        var result = _encodingJapanese.default.convert(codes, {
          to: 'UNICODE',
          from: encode,
          type: 'string'
        });
        // UTF8で変換した結果に日本語が含まれない場合はSJISでリトライ
        if (encode !== 'SJIS' && !/[\u3000-\u9FFF]/.test(result.substring(0, 200))) {
          result = _encodingJapanese.default.convert(codes, {
            to: 'UNICODE',
            from: 'SJIS',
            type: 'string'
          });
        }
        resolve(result);
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = function () {
      reject(new Error('ファイルの読み込みに失敗しました'));
    };
    reader.readAsArrayBuffer(file);
  });
}

/**
 * TSVテキストをパースしてオブジェクト配列に変換
 */
function parseTsv(text) {
  var lines = text.split(/\r?\n/).filter(function (line) {
    return line.trim() !== '';
  });
  if (lines.length < 2) {
    throw new Error('データ行がありません');
  }
  var headers = lines[0].split('\t');
  var rows = [];
  for (var i = 1; i < lines.length; i++) {
    var values = lines[i].split('\t');
    var row = {};
    for (var j = 0; j < headers.length; j++) {
      row[headers[j]] = j < values.length ? values[j] : '';
    }
    rows.push(row);
  }
  return {
    headers: headers,
    rows: rows
  };
}

/**
 * ヘッダーバリデーション: 期待ヘッダーのうち5つ以上一致しなければエラー
 */
function validateHeaders(headers) {
  var matchCount = 0;
  for (var i = 0; i < EXPECTED_HEADERS.length; i++) {
    if (headers.indexOf(EXPECTED_HEADERS[i]) !== -1) {
      matchCount++;
    }
  }
  if (matchCount < 5) {
    throw new Error('D-Managementのファイル形式と一致しません（一致ヘッダー数: ' + matchCount + '）');
  }
}

/**
 * YYYYMMDD → YYYY/M/D に変換
 */
function convertDateYYYYMMDD(value) {
  if (!value) return '';
  var str = value.toString().trim();
  if (str.length !== 8) return str;
  var year = parseInt(str.substring(0, 4), 10);
  var month = parseInt(str.substring(4, 6), 10);
  var day = parseInt(str.substring(6, 8), 10);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return str;
  return year + '/' + month + '/' + day;
}

/**
 * 年のみ → YYYY/1/1 に変換
 */
function convertYearOnly(value) {
  if (!value) return '';
  var str = value.toString().trim();
  if (!str || isNaN(parseInt(str, 10))) return str;
  return parseInt(str, 10) + '/1/1';
}

/**
 * 会員名の空白除去
 */
function cleanMemberName(value) {
  if (!value) return '';
  return value.toString().replace(/\s+/g, '');
}

/**
 * 設立年月日の取得: 設立年 > 創業ｏｒ設立年 の優先順
 */
function getEstablishedYear(row) {
  var value = (row['設立年'] || '').toString().trim();
  if (!value) {
    value = (row['創業ｏｒ設立年'] || '').toString().trim();
  }
  return convertYearOnly(value);
}

/**
 * D-Managementの1行を標準フォーマットの値配列に変換
 */
function mapRow(row, prefixCode) {
  var mapped = {};

  // 基本マッピング
  for (var srcCol in COLUMN_MAP) {
    if (Object.prototype.hasOwnProperty.call(COLUMN_MAP, srcCol)) {
      var dstCol = COLUMN_MAP[srcCol];
      // 設立年月日は特殊処理するのでスキップ
      if (srcCol === '設立年' || srcCol === '創業ｏｒ設立年') continue;
      if (row[srcCol] != null && !mapped[dstCol]) {
        mapped[dstCol] = (row[srcCol] || '').toString().trim();
      }
    }
  }

  // 特殊処理: 会員IDに都道府県コードを付与
  if (prefixCode && mapped['会員ID']) {
    mapped['会員ID'] = prefixCode + mapped['会員ID'];
  }

  // 特殊処理: 会員名の空白除去
  mapped['会員名'] = cleanMemberName(row['会員名']);
  // 特殊処理: 会員名フリガナの空白除去
  mapped['会員名_ふりがな'] = cleanMemberName(row['会員名フリガナ']);

  // 特殊処理: 入会年
  mapped['入会年'] = convertDateYYYYMMDD(row['入会年']);

  // 特殊処理: 設立年月日
  mapped['設立年月日'] = getEstablishedYear(row);

  // 出力ヘッダー順に値配列を生成
  return OUTPUT_HEADERS.map(function (header) {
    return mapped[header] || '';
  });
}

/**
 * s2ab: string to ArrayBuffer
 */
function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

/**
 * メイン: D-ManagementのTXTファイルを標準フォーマットのExcelに変換してダウンロード
 */
function convertDmanagementToExcel(_x, _x2) {
  return _convertDmanagementToExcel.apply(this, arguments);
}
function _convertDmanagementToExcel() {
  _convertDmanagementToExcel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, zoneId) {
    var text, parsed, prefixCode, data, sheetData, ws, range, R, C, cell, cellRef, wb, wsName, wbout, baseName;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return readFileAsText(file);
        case 1:
          text = _context.v;
          // TSVパース
          parsed = parseTsv(text); // ヘッダーバリデーション
          validateHeaders(parsed.headers);

          // zoneIdから都道府県コードプレフィックスを取得
          prefixCode = zoneId ? ZONE_PREFIX_MAP[zoneId.toString()] || '' : ''; // データ変換
          data = parsed.rows.map(function (row) {
            return mapRow(row, prefixCode);
          }); // Excel生成
          sheetData = [OUTPUT_HEADERS].concat(data);
          ws = {};
          range = {
            s: {
              c: 10000000,
              r: 10000000
            },
            e: {
              c: 0,
              r: 0
            }
          };
          R = 0;
        case 2:
          if (!(R < sheetData.length)) {
            _context.n = 7;
            break;
          }
          C = 0;
        case 3:
          if (!(C < sheetData[R].length)) {
            _context.n = 6;
            break;
          }
          if (range.s.r > R) range.s.r = R;
          if (range.s.c > C) range.s.c = C;
          if (range.e.r < R) range.e.r = R;
          if (range.e.c < C) range.e.c = C;
          cell = {
            v: sheetData[R][C]
          };
          if (!(cell.v == null || cell.v === '')) {
            _context.n = 4;
            break;
          }
          return _context.a(3, 5);
        case 4:
          cellRef = _xlsx.default.utils.encode_cell({
            c: C,
            r: R
          });
          if (typeof cell.v === 'number') cell.t = 'n';else cell.t = 's';
          ws[cellRef] = cell;
        case 5:
          ++C;
          _context.n = 3;
          break;
        case 6:
          ++R;
          _context.n = 2;
          break;
        case 7:
          if (range.s.c < 10000000) ws['!ref'] = _xlsx.default.utils.encode_range(range);
          wb = {
            SheetNames: [],
            Sheets: {}
          };
          wsName = _defaultFormat.defaultFormat.sheetName;
          wb.SheetNames.push(wsName);
          wb.Sheets[wsName] = ws;
          wbout = _xlsx.default.write(wb, {
            bookType: 'xlsx',
            bookSST: false,
            type: 'binary'
          }); // ファイル名: 元ファイル名_converted.xlsx
          baseName = file.name.replace(/\.[^.]+$/, '');
          (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], {
            type: 'application/octet-stream'
          }), baseName + '_converted.xlsx');
        case 8:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _convertDmanagementToExcel.apply(this, arguments);
}